/**
 * Window event that asks the app shell to open the sign-in modal.
 *
 * SignInProvider lives inside AppShell, so anything rendered above the shell —
 * the onboarding card is the one case today — cannot reach `useSignIn` through
 * React context. Rather than hoist the provider (and pull the modal, its
 * focus lock and its animation into the first paint of every visit), those
 * callers dispatch this event and the provider listens for it.
 *
 * Kept in its own module so a caller does not have to import the modal to name
 * the event, which would defeat the code splitting this exists to preserve.
 */
export const OPEN_SIGN_IN_EVENT = 'baba:open-sign-in'

/** Detail carried by the event. `intent` selects the modal's copy. */
export interface OpenSignInEventDetail {
  intent?: string
}
